const routes = {
  home: "/", // Trang chính
  add: "/add", // người dùng tích điểm
  history: "/history", // Lịch sử tích điểm

  admin: "/admin", // Dashboard admin (AdminDashboardPage)

  driverDetail: "/driver/:id", // Chi tiết xe (VehicleDetailPage)
  driverCheckIn: "/driver/check-in/:id", // Upload check-in hàng ngày (CheckInUploadPage)
  driverWash: "/driver/wash/:id", // Upload rửa xe (WashUploadPage)
  driverHistory: "/driver/history", // Upload rửa xe (WashUploadPage)

  login: "/login", // Đăng nhập (LoginPage)
  link: "/link", // link dev
  gioVang: "/giovang", // link dev
  vongquay: "/vongquay", // link dev
  notFound: "*",

};

export default routes;
